<template>
    <tr class="apartment-row js-apartment-row--ground">
        <td>
            <span v-if="showAddButton" @click="handleAdd()" class="add-row-button glyphicon glyphicon-plus-sign"></span>
            <select v-model="apartment.size">
                <option v-for="size in apartmentSizeSelectList" :key="size.id" :value="size.id">{{ size.label }}</option>
            </select>
        </td>
        <td>
            <input class="form-control" v-model.number="apartment.area" type="number"/>
        </td>
        <td>
            <input class="form-control" v-model.number="apartment.count" type="number"/>
            <span v-if="showRemoveButton" @click="handleRemove(apartment)" class="remove-row-button glyphicon glyphicon-minus-sign"></span>
        </td>
    </tr>
</template>

<script>
    import {mapGetters} from "vuex"
    import _ from "lodash"

    export default {
        props: {
            apartment: {type: Object},
            showRemoveButton: {type: Boolean, default: true},
            showAddButton: {type: Boolean, default: false},
            handleAdd: {type: Function},
            handleRemove: {type: Function}
        },

        computed: {
            ...mapGetters([
                "apartmentSizes",
                "procurementModel"
            ]),

            apartmentSizeSelectList() {
                const isCorona = this.procurementModel === 4;
                const whiteList = isCorona ? [0, 3, 5, 6, 7, 13] : [0, 3, 5, 6, 7, 8];
                const list = _.filter(this.apartmentSizes, size => whiteList.indexOf(size.id) > -1)
                return _.orderBy(list, "label")
            }
        }
    }
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// assets/vue/houseModel/components/customRefHouseApartment.vue